import { useState, useEffect } from "react";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";


const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [countryDrp, setCountryDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [error, setError] = useState([]);
  const [planName, setPlanName] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    image: "",
    image_url: "",
    address: "",
    gst_no: "",
    email: "",
    contact_no: "",
    pincode: "",
    website: "",
    password: "",
    country_id: "",
    city_id: "",
    state_id: "",
  });

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formData.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formData.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (isInvalid(formData.name)) {
      toast.error("Name Is Required");
      return false;
    }
    if (isInvalid(formData.email)) {
      toast.error("Email Is Required");
      return false;
    }
    if (isInvalid(formData.contact_no)) {
      toast.error("Contact Number Is Required");
      return false;
    }
    setError([]);
    setLoading(true);
    let url = API_URL.SAVE_USER;
      axios.post(url, formData).then(
        (response) => {
          setLoading(false);
          if (response.data.status === 1) {
            toast.success("Setting Updated Successfully", { autoClose: 3000 });
          } else {
            if (response.data && response.data.data) {
              let errors = [];
              Object.keys(response.data.data).forEach((key) => {
                errors.push(response.data.data[key][0]);
              });
              setError(errors);
              toast.error("Something went wrong..", { autoClose: 3000 });
            }
          }
        },
        (error) => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  const getUser = () => {
    axios.post(API_URL.LOGIN_USER).then((res) => {
      if (res.data.data) {
        setFormData({
          name: res.data.data.name || "",
          address: res.data.data.address || "",
          email: res.data.data.email || "",
          image: "",
          contact_no: res.data.data.contact_no || "",
          country_id: res.data.data.country_id || "",
          city_id: res.data.data.city_id || "",
          state_id: res.data.data.state_id || "",
          gst_no: res.data.data.gst_no || "",
          pincode: res.data.data.pincode || "",
          website: res.data.data.website || "",
        });
        if (res.data.data.image) {
          setImagePreview(res.data.data.image)
        }
        setPlanName(res.data.data.plan_name);
      }
    });
  };

  const isInvalid = (value) => {
    return !value || value === "" || value === null;
  };

  useEffect(() => {
    getCountryDrpData();
  }, []);

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    getStateDrpData();
  }, [formData.country_id]);

  useEffect(() => {
    getCityDrpData();
  }, [formData.state_id]);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Profile Details <span class="badge badge-warning">{planName}</span></h4>
            <form onSubmit={onSubmit}>
              <div className="">
                <div className="d-flex">
                  <div className="me-4">
                    <div className="col-md-4">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Image</label>
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"rect"}
                              aspectRatio={'BLOG'}
                              guid={""}
                              width={250}
                              height={150}
                              onChangeCropper={async ({
                                fileCropped,
                                fileCroppedBase64,
                              }) => {
                                setFormData({
                                  ...formData,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                                //   await uploadFile(fileCropped)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Name</label>
                        <input
                          className="form-control"
                          name="title"
                          type="text"
                          value={formData.name ?? ""}
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              name: event.target.value,
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Address</label>
                        <input
                          className="form-control"
                          name="title"
                          type="text"
                          value={formData.address ?? ""}
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              address: event.target.value,
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          className="form-control"
                          name="title"
                          type="text"
                          value={formData.email ?? ""}
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              email: event.target.value,
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Mobile Number</label>
                        <input
                          className="form-control"
                          name="title"
                          type="text"
                          value={formData.contact_no ?? ""}
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              contact_no: event.target.value,
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="name">Pin Code</label>
                        <input
                          type="number"
                          name="Pin code"
                          maxLength={30}
                          value={formData.pincode}
                          className="form-control"
                          id="Pin code"
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              pincode: event.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="Country">Country</label>
                        <Select
                          placeholder="Select Country"
                          options={countryDrp}
                          value={countryDrp.find(
                            (r) => r.value == formData.country_id
                          )}
                          styles={styles}
                          onChange={(e) =>
                            setFormData({ ...formData, country_id: e.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="State">State</label>

                        <Select
                          placeholder="Select State"
                          options={stateDrp}
                          value={stateDrp.find(
                            (r) => r.value == formData.state_id
                          )}
                          styles={styles}
                          onChange={(e) =>
                            setFormData({ ...formData, state_id: e.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="City">City</label>
                        <Select
                          placeholder="Select City"
                          options={cityDrp}
                          value={cityDrp.find(
                            (r) => r.value == formData.city_id
                          )}
                          styles={styles}
                          onChange={(e) =>
                            setFormData({ ...formData, city_id: e.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Gst Number</label>
                        <input
                          className="form-control"
                          name="title"
                          type="text"
                          value={formData.gst_no ?? ""}
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              gst_no: event.target.value,
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="name">Website</label>
                        <input
                          type="text"
                          name="website"
                          value={formData.website}
                          className="form-control"
                          id="website"
                          onChange={(event) => {
                            setFormData({
                              ...formData,
                              website: event.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 text-right">
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Update"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
